import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0054ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-recent" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" — ")
const _hoisted_3 = {
  key: 0,
  class: "item-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppBadge = _resolveComponent("AppBadge")!
  const _component_AppDateTime = _resolveComponent("AppDateTime")!
  const _component_StringLinkList = _resolveComponent("StringLinkList")!
  const _component_StringLinkInfo = _resolveComponent("StringLinkInfo")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.history, (item, hIdx) => {
        return (_openBlock(), _createElementBlock("li", { key: hIdx }, [
          _createElementVNode("div", null, [
            _createVNode(_component_AppBadge, {
              priority: item.priority
            }, null, 8, ["priority"]),
            _createVNode(_component_AppDateTime, {
              dt: item.timestamp
            }, null, 8, ["dt"]),
            _hoisted_2,
            _createVNode(_component_StringLinkList, {
              list: _ctx.processLine(item.summary),
              highlight: [],
              onLinkClick: ($event: any) => (_ctx.showInfo($event, hIdx))
            }, null, 8, ["list", "onLinkClick"])
          ]),
          (_ctx.currentInfo && _ctx.currentIdx === hIdx)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_StringLinkInfo, {
                  str: _ctx.currentInfo,
                  highlight: [],
                  onItemClick: ($event: any) => (_ctx.showInfo($event, hIdx))
                }, null, 8, ["str", "onItemClick"])
              ]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ])
  ]))
}